import type { FlightSearchPagedResultData } from "@/app/lib/hooks/flightSearch/types";

import type {
  FullOfferType,
  MappedFlightOffer,
} from "../../context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";

export const isFlightOffer = (
  offer: FullOfferType,
): offer is MappedFlightOffer => {
  return offer.type === "FLIGHT_OFFER";
};

export const getOfferByIdFromSearchResult = (
  response: FlightSearchPagedResultData,
  offerId: string | null,
) => {
  const offers = response.pages.flatMap((page) => page.offers);
  const selectedOffer = offers.find(
    (offer): offer is MappedFlightOffer =>
      isFlightOffer(offer) && offer.index === offerId,
  );
  return selectedOffer;
};
